import { AdminTask, AdminTaskMap, UserPermissions } from 'types';

interface AdminTaskFlags {
  replayFailedDirectPayLogsFlag?: boolean;
}

/**
 * The first admin task the user can actually open: its menu permissions are
 * satisfied (the user holds all of them) and it isn't hidden behind an off
 * feature flag. Used for the default redirect and the "Back to Tasks" link so we
 * never land on a task that's gated out of the user's menu.
 */
export const getFirstAccessibleTaskKey = (
  userPermissions: UserPermissions[],
  flags: AdminTaskFlags,
): AdminTask | undefined => {
  const entries = Object.entries(AdminTaskMap) as [AdminTask, (typeof AdminTaskMap)[AdminTask]][];
  const accessible = entries.find(
    ([key, task]) =>
      (key !== AdminTask.replayFailedDirectPayLogs || flags.replayFailedDirectPayLogsFlag) &&
      task.neededPermissions.every((permission) => userPermissions.includes(permission)),
  );
  return accessible?.[0];
};
